<div class="wrapper">
  <app-sidebar></app-sidebar>
  <div class="main">
    <app-header></app-header>
    <main class="content px-3 pt-1 pb-0">
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>
  </div>
</div>
